export default __webpack_public_path__ + "static/media/noContent.4e11707e.svg";